import { create } from 'zustand'
import type { Alert, AlertEvent } from '../types'

interface AlertState {
  alerts: Alert[];
  events: AlertEvent[];
  unreadCount: number;
  setAlerts: (alerts: Alert[]) => void;
  setEvents: (events: AlertEvent[]) => void;
  addAlert: (alert: Alert) => void;
  updateAlert: (id: string, data: Partial<Alert>) => void;
  removeAlert: (id: string) => void;
  markRead: (eventId: string) => void;
  markAllRead: () => void;
  setUnreadCount: (count: number) => void;
}

export const useAlertStore = create<AlertState>((set) => ({
  alerts: [],
  events: [],
  unreadCount: 0,

  setAlerts: (alerts) => set({ alerts }),

  setEvents: (events) => {
    const unreadCount = events.filter(e => !e.is_read).length
    set({ events, unreadCount })
  },

  addAlert: (alert) => set((state) => ({
    alerts: [alert, ...state.alerts]
  })),

  updateAlert: (id, data) => set((state) => ({
    alerts: state.alerts.map(alert =>
      alert.id === id ? { ...alert, ...data } : alert
    )
  })),

  removeAlert: (id) => set((state) => ({
    alerts: state.alerts.filter(alert => alert.id !== id)
  })),

  markRead: (eventId) => set((state) => ({
    events: state.events.map(event =>
      event.id === eventId ? { ...event, is_read: true } : event
    ),
    unreadCount: Math.max(0, state.unreadCount - 1)
  })),

  markAllRead: () => set((state) => ({
    events: state.events.map(event => ({ ...event, is_read: true })),
    unreadCount: 0
  })),

  setUnreadCount: (unreadCount) => set({ unreadCount }),
}))
